var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.94 208.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.08,5.05c-5.87-1.48-12-3.18-18.19-5l-.12.45S.53,100,.09,102.31s.88,14,1.33,14.44,6.42,3.73,6.64,5.36,2.88,12.59,3.32,12.82,1.55-.47,2.22.93.22,4,.88,4.43,2.66-.7,4,.93-.67,7.23,1.1,7.69,4.43,0,4.88,2.8,4,13.28,6.64,16.08,5.52,7.5,6,9.32a15.3,15.3,0,0,1,.22,8.15c-.79,2.6-2.95,3-2.66,6.06.19,2,3.19,6.59,5.27,9.58,13.86,2.89,27.79,5.37,40.57,7l2.11.26.09,0,27.25-189.2,0-.15C89.26,15.32,67.08,10.87,44.08,5.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb);
export default __webpack_public_path__ + "static/media/AB.56d535673e88ea735c114365c5c98479.svg";
export { ForwardRef as ReactComponent };